import { useQuery } from '@tanstack/react-query'

import chatService from '../services'

export const chatNotesQueryKey = (roomId: string) => ['chat', 'notes', roomId]

export function useQueryChatNotes(roomId: string, enabled = true) {
	return useQuery({
		queryKey: chatNotesQueryKey(roomId),
		queryFn: () => chatService.getChatNotes(roomId),
		enabled: enabled && !!roomId,
	})
}
